module.exports = __webpack_public_path__ + "img/paypredict-logo.35daba0e.svg";